define('views/customer-logo-view',[
  'jquery',
  'utils/view',
  'server-settings',
  'modules/customer-logo-upload',
  'modules/overlay-box',
  'modules/magnify-image-box'
], function ($, View, serverSettings, CustomerLogoUpload, OverlayBox, MagnifyImageBox) {
  var CustomerLogoView = (function () {
    function CustomerLogoView() {}

    CustomerLogoView.prototype.InitBindings = function () {
      var _this = this;

      new CustomerLogoUpload(
        $('#btnPopupLogoUpload'),
        function (data) {
          var listing = $('#CustomerLogoListing');

          if (!_this.customerLogoTemplate) {
            _this.customerLogoTemplate = Handlebars.compile($('#logoContentTemplate').html());
          }

          $($.parseHTML(_this.customerLogoTemplate(data).replace(/^\s+|\s+$/gm, '')))
            .fadeTo(0)
            .prependTo(listing)
            .fadeTo(500, 1);
        },
        function (error) {
          // todo, handle error, toast user
          console.log('error in view: ', error);
        }
      );

      $('#CustomerLogoListing').on('click', '.link--delete', function (event) {
        var ob = new OverlayBox($('#popupLogoDeleteTemplete'), {});
        ob.setup();
        ob.load(function () {
          ob.show();
        });

        var target = $(event.target).closest('[data-logo-id]');

        $('#popupBtnLogoDelete').click(function (event) {
          event.preventDefault();
          var id = target.data('logo-id');

          $.ajax({
            method: 'DELETE',
            url: serverSettings.customerLogoApi + '/' + id
          }).success(function (data) {
            if (data === true) {
              target.fadeTo(500, 0, function () {
                target.css('display', 'none');
              });
            }
          });

          ob.destroy();
        });

        $('#popupBtnLogoDeleteAbort').click(function (event) {
          event.preventDefault();
          ob.destroy();
        });
      });
    };

    $('#CustomerLogoListing').on('click', '.customer-logo-image', function (e) {
      var url = $(e.target).closest('[data-logo-id]').data('logo-image');
      var magnifyImageBox = new MagnifyImageBox({
        isImage: true,
        src: url
      });
      magnifyImageBox.show();
    });

    return CustomerLogoView;
  })();

  return View('CustomerLogoView', function () {
    var v = new CustomerLogoView();

    v.InitBindings();
  });
});

